import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { ChevronRight, LogOut, User, ScanLine, Sparkles, Crown, MessageCircle, ShoppingBag, Heart } from "lucide-react";
import { useAuth } from "../../context/AuthContext";

const ITEMS = [
  { to: "/app/fit-profile", icon: Sparkles, label: "My Fit Profile" },
  { to: "/app/loyalty", icon: Crown, label: "Loyalty & VIP Drops" },
  { to: "/app/authenticity", icon: ScanLine, label: "Authenticity & Warranty" },
  { to: "/app/concierge", icon: MessageCircle, label: "Concierge Chat" },
  { to: "/app/cart", icon: ShoppingBag, label: "Bag" },
  { to: "/app/wishlist", icon: Heart, label: "Saved" },
];

export default function AppProfile() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div data-testid="app-profile" className="pb-6">
      <header className="px-5 pt-12">
        <div className="text-[11px] tracking-luxury uppercase text-poche-gold">Profile</div>
      </header>

      {user ? (
        <div className="mx-5 mt-3 bg-poche-ink border border-poche-gold/30 p-5 flex items-center gap-4">
          <div className="w-14 h-14 rounded-full bg-poche-gold flex items-center justify-center text-poche-black font-serif text-xl">
            {user.name.charAt(0)}
          </div>
          <div className="flex-1">
            <div className="font-serif text-xl">{user.name}</div>
            <div className="text-xs text-white/55">{user.email}</div>
            <div className="text-[10px] tracking-luxury uppercase text-poche-gold mt-1">{user.loyalty_tier} · {user.loyalty_points} pts</div>
          </div>
        </div>
      ) : (
        <div className="mx-5 mt-3 p-5 border border-white/10 text-center">
          <User size={26} className="text-poche-gold mx-auto" strokeWidth={1.4} />
          <div className="font-serif text-xl mt-2">Sign in to POCHE</div>
          <Link to="/login" className="btn-gold mt-4 inline-flex !py-2.5 !px-5 text-[10px]">Sign In</Link>
        </div>
      )}

      <div className="mt-6 divide-y divide-white/10 border-t border-b border-white/10">
        {ITEMS.map((it) => (
          <Link key={it.to} to={it.to} data-testid={`profile-link-${it.label.toLowerCase().replace(/\s+/g, "-")}`} className="flex items-center px-5 py-4 hover:bg-poche-ink">
            <it.icon size={18} className="text-poche-gold" strokeWidth={1.4} />
            <span className="ml-4 flex-1 text-sm">{it.label}</span>
            <ChevronRight size={16} className="text-white/35" />
          </Link>
        ))}
      </div>

      {user && (
        <div className="px-5 mt-6">
          <button data-testid="app-logout" onClick={async () => { await logout(); navigate("/app"); }} className="border border-white/15 w-full py-3 text-[11px] tracking-luxury uppercase text-white/65 flex items-center justify-center gap-2 hover:text-poche-gold hover:border-poche-gold">
            <LogOut size={14} /> Sign Out
          </button>
        </div>
      )}

      <div className="text-center text-[10px] tracking-luxury uppercase text-white/35 mt-8">POCHE App · v1.0 · Built For Real Faces</div>
    </div>
  );
}
